module.exports = __webpack_public_path__ + "img/2_01.884529ad.jpg";